import * as React from 'react';
import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { Switch as SwitchPrimitive } from '@base-ui/react/switch';

import { cn } from '../../lib/utils';

function Checkbox({
  className,
  checked,
  onCheckedChange,
  ...props
}: CheckboxPrimitive.Root.Props & {
  onCheckedChange?: (checked: boolean) => void;
}) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={cn(
        'border-input bg-background text-primary-foreground flex size-4 shrink-0 items-center justify-center rounded border outline-none focus-visible:border-green-600 focus-visible:ring-3 focus-visible:ring-green-600/30 data-checked:border-green-600 data-checked:bg-green-600',
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator className="text-current">
        <svg viewBox="0 0 16 16" fill="none" className="size-3.5">
          <path
            d="M3.5 8.5L6.5 11.5L12.5 4.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

function Switch({
  className,
  checked,
  onCheckedChange,
  ...props
}: SwitchPrimitive.Root.Props & {
  onCheckedChange?: (checked: boolean) => void;
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={cn(
        'border-input bg-muted relative inline-flex h-5 w-9 shrink-0 items-center rounded-full border transition-colors outline-none focus-visible:ring-3 focus-visible:ring-green-600/30 data-checked:border-green-600 data-checked:bg-green-600',
        className
      )}
      {...props}>
      <SwitchPrimitive.Thumb
        className={cn(
          'bg-background pointer-events-none block size-4 translate-x-0.5 rounded-full shadow transition-transform data-checked:translate-x-[18px]'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

function Spinner({
  className,
  size,
  ...props
}: React.ComponentProps<'div'> & {
  size?: 'small' | 'large' | string | number;
}) {
  const sizeClass =
    size === 'large' || size === 'lg'
      ? 'size-8'
      : size === 'small' || size === 'sm'
        ? 'size-4'
        : 'size-5';
  return (
    <div
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn(
        'border-muted animate-spin rounded-full border-2 border-t-green-600',
        sizeClass,
        className
      )}
      {...props}
    />
  );
}

export { Checkbox, Switch, Spinner };
